const {
  hostname,
  protocol
} = window.location;
function getEnvironment() {
  if (hostname.endsWith('.test')) {
    return 'e2e';
  }
  if (hostname === 'localhost' || hostname === '127.0.0.1' || protocol === 'http:') {
    return 'local';
  }
  if (hostname.startsWith('dev.')) {
    return 'dev';
  }
  return 'prod';
}
export const environment = getEnvironment();
//# sourceMappingURL=index.js.map